export type SseEvent = {
  event: string;
  data: unknown;
};

export function encodeSse(event: string, data: unknown): string {
  const payload = JSON.stringify(data);
  return `event: ${event}\ndata: ${payload}\n\n`;
}

export class SseDecoder {
  private buffer = "";

  push(text: string): SseEvent[] {
    this.buffer += text;
    const parts = this.buffer.split("\n\n");
    this.buffer = parts.pop() ?? "";
    const events: SseEvent[] = [];
    for (const part of parts) {
      if (!part.trim()) continue;
      let event = "message";
      const dataLines: string[] = [];
      for (const line of part.split("\n")) {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) dataLines.push(line.slice(5).trim());
      }
      if (dataLines.length === 0) continue;
      try {
        events.push({ event, data: JSON.parse(dataLines.join("\n")) as unknown });
      } catch {
        events.push({ event, data: dataLines.join("\n") });
      }
    }
    return events;
  }
}

/** Workers AI streams sometimes send a delta and sometimes the full text so far. */
export function workersAiTextDelta(previous: string, response: string): { next: string; delta: string } {
  if (!response) return { next: previous, delta: "" };
  if (response.startsWith(previous)) return { next: response, delta: response.slice(previous.length) };
  return { next: previous + response, delta: response };
}
